import React, { useState } from "react";
import { classnames } from "@culturehq/components";
import { showUnsplashImageFinder, t } from "app/utils";
import LazyEditor from "components/editor/LazyEditor";
import SelectTags from "components/post/SelectTags";
import { useIsLoggedIn } from "app/hooks";
import { Organization } from "chq";
import { usePostStoryContext } from "../../contexts/PostStoryContext";
import { DefaultStory } from "../../types";

const BASE_SECTIONS = ["inlineStyleAndLink", "block", "undo"];

const defaultStory: DefaultStory = {
  question: null,
  body: null
};

const PostStoryEditor = () => {
  const isLoggedIn = useIsLoggedIn();
  const {
    organization,
    state: {
      currentBody,
      currentStory,
      progress,
      selectedPrompt,
      selectedImages,
      selectedOptions
    },
    editorRef,
    handleOnChangeBody,
    onShareWithChanged,
    onChange
  } = usePostStoryContext();
  const story = currentStory || defaultStory;
  const [editorPadding, setEditorPadding] = useState({ paddingBottom: "55px" });
  const allowedSections = isLoggedIn ? ["mention", ...BASE_SECTIONS] : [...BASE_SECTIONS];

  const textEditorClass = () => (showUnsplashImageFinder(organization as Organization, selectedPrompt) ? selectedPrompt?.allowedTypes : "no-find");

  const handleOnChange = (value: string) => {
    handleOnChangeBody(value);
    onChange();
  };

  const handleShareWithChanged = (newOptions: any[], selectHeight: number) => {
    onShareWithChanged(newOptions);
    setEditorPadding({ paddingBottom: `${selectHeight + 10}px` });
  };

  return (
    <div className={classnames("RightColumn-Row", "chq-ffd", "LazyEditor-Container", selectedImages.length > 0 ? "just_images" : textEditorClass())}>
      {progress !== 100 && (
        <LazyEditor
          sections={allowedSections}
          ref={editorRef}
          initialValue={currentBody || story.body}
          placeholder={t("Add a message here...")}
          onChange={handleOnChange}
          style={editorPadding}
        />
      )}
      <div className="add-tags">
        <SelectTags
          placeholder={t("Add tags to personalize your story")}
          selectedOptions={selectedOptions}
          onShareWithChanged={handleShareWithChanged}
          setEditorPadding={setEditorPadding}
          withOrgValues
        />
      </div>
    </div>
  );
};

export default PostStoryEditor;
